import axios from '../../axios/axiosdb';
import * as actionTypes from './actionTypes';
import {getRandomId, listOfPostFromResponse, postObjectFromResponse} from "../../Utils/utils";

export const postInit = () => {
    return {
        type: actionTypes.POST_INIT
    }
}

const postStart = () => {
    return {
        type: actionTypes.POST_START
    }
}

export const postSuccess = (posts) => {
    return {
        type: actionTypes.POST_SUCCESS,
        posts
    }
}

const postFail = (error) => {
    return {
        type: actionTypes.POST_FAIL,
        error
    }
}

export const post = (url, queryParams = "") => {
    return dispatch => {
        // TODO Do I need postInit?
        dispatch(postInit())
        dispatch(postStart())
        axios
            .get(url + queryParams)
            .then(response => {
                const posts = listOfPostFromResponse(response)
                dispatch(postSuccess(posts))
            })
            .catch(error => {
                console.log(error)
                dispatch(postFail(error))
            })
    }
}

export const detailedPost = (url, postId) => {
    return dispatch => {
        dispatch(postInit())
        dispatch(postStart())
        axios
            .get(url)
            .then(response => {
                const post = postObjectFromResponse(response.data, postId)
                dispatch(postSuccess([post]))
            })
            .catch(error => {
                console.log(error)
                dispatch(postFail(error))
            })
    }
}

const postToggleUpVoteSuccess = (id, flag) => {
    return {
        type: actionTypes.POST_TOGGLE_UPVOTE_SUCCESS,
        id,
        flag
    }
}

export const postToggleUpVote = (id, postId, postOwnerUserId, upVoteUserId, points, flag, token) => {
    return dispatch => {
        dispatch(postToggleUpVoteSuccess(id, flag))
        // TODO Rest api call to backend for updating the upvote
        // TODO On failed api call update the upvote

        const authToken = "?auth=" + token

        const point = flag ? -1 : 1
        const totalPoints = +points + point

        axios.put("/posts/" + postId + "/points.json" + authToken, totalPoints.toString())
        axios.put("/posts/" + postId + "/upVoteBy/" + upVoteUserId + ".json" + authToken, point)

        axios.put("/userposts/" + postOwnerUserId + "/" + postId + "/points.json" + authToken, totalPoints.toString())
        axios.put("/userposts/" + postOwnerUserId + "/" + postId + "/upVoteBy/" + upVoteUserId + ".json" + authToken, point)

    }
}

export const postSubmitInit = () => {
    return {
        type: actionTypes.POST_SUBMIT_INIT
    }
}

const postSubmitStart = () => {
    return {
        type: actionTypes.POST_SUBMIT_START
    }
}

const postSubmitSuccess = () => {
    return {
        type: actionTypes.POST_SUBMIT_SUCCESS
    }
}

const postSubmitFail = (error) => {
    return {
        type: actionTypes.POST_SUBMIT_FAIL,
        error
    }
}

export const postSubmit = (userId, postData, token) => {
    return dispatch => {
        dispatch(postSubmitStart())
        const postId = getRandomId()
        const authToken = "?auth=" + token
        // All post
        axios
            .put("/posts/" + postId + ".json" + authToken, postData)
            .then(response => {
                //console.log(response)
                dispatch(postSubmitSuccess())
            })
            .catch(error => {
                console.log(error)
                dispatch(postSubmitFail(error))
            })

        // User post
        axios
            .put("/userposts/" + userId + "/" + postId + ".json" + authToken, postData)
            .then(response => {
                //console.log(response)
            })
            .catch(error => {
                console.log(error)
            })
    }
}